module.exports = __webpack_public_path__ + "resources/img/main04_m.f9238c0cae6d20f73f4155ec5b9e17a6.jpg";